import { getOperatorsString } from './operators';

export function debounce(fn, delay) {
  let timer = null;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, arguments), delay);
  };
}

/* eslint-disable no-useless-escape */

export const getRegionsString = (arr) => {
  return arr.map((r) => r?.name);
};

export const getCirclesString = (selectedCircles) => {
  return selectedCircles.map(circle => circle?.name);
};

export const getCitiesString = (selectedCities) => {
  return selectedCities.map(city => city?.name);
};

export const getSitesString = (arr) => {  
  return arr.map((s) => s?.nodeId);
};

export const getFilterString = (filterObj, searchString) => {
  let filter = '';

  if (Object.keys(filterObj).length === 0) {
    filter = '*';
  } else {
    const filterStrings = [];
    const newFilterStrings = Object.values(filterObj)
      .filter((f) => f.value)
      .map((f) =>
        getOperatorsString(
          f.operator,
          f.field.fieldType === "alarm" && f.field.name === "node.name" && typeof f.value === "string" ? f.field.widget.transformValue([f.value]) : f.field.widget.transformValue(f.value),
          f.field.name
        )
      );
    newFilterStrings?.forEach((s) => {
      if (s) {
        filterStrings.push(`(${s})`);
      }
    });
    if (filterStrings.length) {
      filter = filterStrings.join(' AND ');
    }
  }

  let operFound = false
  let filterbinObj = {}
  if (searchString) {
    if (searchString.includes(' AND ') || searchString.includes(' and ') || searchString.includes(' OR ') || searchString.includes(' or ') || searchString.includes('=')) {
      operFound = true
      let tempArr = searchString.split(/=| = | and /g)
      let tempObj = {}
      for (let inOb = 0; inOb < tempArr.length; inOb++) {
        if ((inOb + 1) % 2 === 1) {
          if (tempArr[inOb + 1]) {
            if (tempObj[tempArr[inOb]]?.length > 0) {
              let splArr = tempArr[inOb + 1].split(/ OR | or /g)
              let tempsplArr = [...tempObj[tempArr[inOb]], ...splArr]
              tempObj[tempArr[inOb]] = tempsplArr
            } else {
              let splArr = tempArr[inOb + 1].split(/ OR | or /g)
              tempObj[tempArr[inOb]] = splArr
            }
          }
        }
      }
      filterbinObj.obj = tempObj

    }
    
    filter =
      filter === '*' || filter.trim() === ''
      ? operFound ? '' : `${searchString}`
        : `${filter} AND (${searchString})`;
    
    if (operFound) {
      filterbinObj.filter = filter
    }
  }

  return operFound ? filterbinObj : filter;
};
